import { Container, Alert, Button, Typography } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

interface ErrorStateProps {
  message: string;
  onRetry: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
      <Alert severity="error" sx={{ mb: 3 }}>
        {message}
      </Alert>

      <Typography variant="body2" color="text.secondary" paragraph>
        Please try again. If the problem persists, contact support.
      </Typography>

      <Button
        variant="outlined"
        startIcon={<RefreshIcon />}
        onClick={onRetry}
      >
        Retry
      </Button>
    </Container>
  );
}
